import { PlanSeq } from '@mobi/api-types'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import type { FollowMeShareTicket } from '@core/Areas/FollowMe/types'

export function isDerivativeBetTypeTicket(ticket: Ticket | FollowMeShareTicket) {
  if (ticket.planSeq !== PlanSeq.FOBRacing) return false
  if (ticket.legs.length > 1) return false
  if (!ticket.legs[0].betType) return false

  const cleanBetType = ticket.legs[0].betType.toLowerCase()
  return !(cleanBetType.includes('win') || cleanBetType.includes('place'))
}
